<section class="invoices-panel">
  <header class="invoices-panel__header">
    <div class="invoices-panel__heading">
      <h2 class="invoices-panel__title">Invoices</h2>
      <p class="invoices-panel__subtitle">
        Billing documents issued to your organization. Select one to open the
        PDF in a new tab.
      </p>
      <div class="invoices-panel__stats" *ngIf="!isLoading && invoices.length">
        <span class="invoices-stat">
          <strong>{{ invoices.length }}</strong>
          {{ invoices.length === 1 ? "invoice" : "invoices" }}
        </span>
        <span class="invoices-stat" *ngIf="latestInvoiceDate">
          Latest <strong>{{ latestInvoiceDate | date: "d MMM y" }}</strong>
        </span>
      </div>
    </div>

    <div class="invoices-panel__tools" *ngIf="invoices.length > 1">
      <div class="invoices-search">
        <i class="material-icons invoices-search__icon">search</i>
        <input
          type="text"
          class="invoices-search__input"
          placeholder="Search by name or date"
          aria-label="Search invoices"
          [(ngModel)]="searchTerm"
        />
        <button
          type="button"
          class="invoices-search__clear"
          *ngIf="searchTerm"
          (click)="clearSearch()"
          aria-label="Clear search"
        >
          <i class="material-icons">close</i>
        </button>
      </div>
    </div>
  </header>

  <div class="invoices-list" *ngIf="!isLoading">
    <div class="invoice-group" *ngFor="let group of invoiceGroups">
      <div class="invoice-group__head">
        <span class="invoice-group__year">{{ group.year }}</span>
        <span class="invoice-group__count">
          {{ group.invoices.length }}
          {{ group.invoices.length === 1 ? "invoice" : "invoices" }}
        </span>
      </div>

      <article
        class="invoice-row"
        *ngFor="let invoice of group.invoices; trackBy: trackByInvoiceId"
        role="button"
        tabindex="0"
        (click)="openInvoice(invoice.url)"
        (keydown.enter)="openInvoice(invoice.url)"
        (keydown.space)="$event.preventDefault(); openInvoice(invoice.url)"
      >
        <div class="invoice-row__identity">
          <div class="invoice-tile" aria-hidden="true">
            <i class="material-icons">picture_as_pdf</i>
          </div>
          <div class="invoice-identity">
            <p class="invoice-name">{{ displayName(invoice) }}</p>
            <p class="invoice-meta">
              <i class="material-icons invoice-meta__icon">event</i>
              {{ invoice.date | date: "d MMMM y" }}
              <span class="invoice-meta__sep">•</span>
              <span class="invoice-format">PDF</span>
            </p>
          </div>
        </div>

        <div class="invoice-row__actions">
          <button
            mat-stroked-button
            type="button"
            class="invoice-open"
            (click)="$event.stopPropagation(); openInvoice(invoice.url)"
          >
            <i class="material-icons">open_in_new</i>
            <span>Open</span>
          </button>
        </div>
      </article>
    </div>

    <div class="invoices-empty" *ngIf="!invoices.length">
      <i class="material-icons invoices-empty__icon">description</i>
      <p class="invoices-empty__title">No invoices yet</p>
      <p class="invoices-empty__text">
        Invoices appear here once your organization has been billed.
      </p>
    </div>

    <div class="invoices-empty" *ngIf="invoices.length && !filteredInvoices.length">
      <i class="material-icons invoices-empty__icon">search_off</i>
      <p class="invoices-empty__title">No invoices match “{{ searchTerm }}”</p>
      <p class="invoices-empty__text">Try a different name, month or year.</p>
      <button type="button" class="invoices-empty__link" (click)="clearSearch()">
        Clear search
      </button>
    </div>
  </div>

  <div class="invoices-list invoices-list--loading" *ngIf="isLoading" aria-busy="true">
    <div class="invoice-skeleton" *ngFor="let placeholder of skeletonRows">
      <div class="skeleton skeleton--tile"></div>
      <div class="invoice-skeleton__lines">
        <div class="skeleton skeleton--line skeleton--line-lg"></div>
        <div class="skeleton skeleton--line skeleton--line-sm"></div>
      </div>
      <div class="skeleton skeleton--action"></div>
    </div>
  </div>
</section>
